<template>
    <div id="wine-info-page">
        <div v-if="!wine" id="wine-info-loading">Loading...</div>
        <div v-else class="wine-info-container">
            <div v-if="currentWineTopAd" v-on:click="handleAdClick(currentWineTopAd)" class="header-banner" style="">
                <img :src="currentWineTopAd.imageBanner | optimizeBanner" alt="">
            </div>
            <div v-if="currentWineTopAd" v-on:click="handleAdClick(currentWineTopAd)" class="header-banner-mobile"  style="">
                <img :src="currentWineTopAd.imageBannerMobile | optimizeBanner" alt="">
            </div>
            <div class="wine-info-content">
                <div class="wine-image-wrap">
                    <div class="wine-image">
                        <img v-if="wine.image != ''" :src="wine.image | optimizeWine" :alt="wine.name">
                        <img v-else src="../assets/wines/wine-placeholder.png" :alt="wine.name">
                    </div>
                    <!--<div class="wine-image-source">Mynd: Vínbúð</div>-->
                </div>
                <div class="wine-info-main">
                    <div class="wine-info-main-marg">
                        <div class="wine-info-main-col1">
                            <!-- <div class="wine-title">Nafn á Víni</div>
                            <div class="wine-description">Upplýsingar um vínið og fleirra</div>
                            <div class="wine-rating">Einkunn: 4,5</div> -->
                            <h1 class="wine-title">{{ wine.name }}</h1>
                            <div class="wine-description">{{ wine.description }}</div>
                            <div class="wine-rating">Einkunn: {{ wine.rating }}</div>
                            <div v-if="wine.ageRating.length > 0" class="wine-ageRating-wrap">
                                <div class="wine-ageRating-title">Árgangar</div>
                                <div v-for="(rating, index) in sortedAgeRating(wine.ageRating)" :key="index" class="wine-ageRating">{{ rating.year }} - {{ rating.rating }}</div>
                            </div>
                            <div v-if="isWineOfTheMonth(wine)" class="wine-wotm">Vín Mánaðarins</div>
                        </div>
                        <div class="wine-info-main-col2">
                            <div class="wine-more-data">
                                <!-- <p>Verð í vínbúð: <span>2.399kr</span></p>
                                <p>Verð í fríhöfn: <span>1.899kr</span></p>
                                <p>Framleiðandi: <span>Lorem ipsum</span></p>
                                <p>Svæði: <span>Norður-Ítalía</span></p>
                                <p>Þrúgur: <span>Barbera</span></p>
                                <p>Áfengisprósenta: <span>3,4%</span></p>
                                <p>Matarpörun: <span>Nautakjöt</span></p> -->
                                <div class="wine-more-data-single"><div class="wine-more-data-single-title"><div v-if="wine.storelink1" class="wine-more-data-single-icon icon-atvr" v-on:click="openUrl(wine.storelink1)"></div>Verð í vínbúð:</div><div class="wine-more-data-single-value">{{ wine.price1 }}kr</div></div>
                                <div class="wine-more-data-single"><div class="wine-more-data-single-title"><div v-if="wine.storelink2" class="wine-more-data-single-icon icon-dutyfree" v-on:click="openUrl(wine.storelink2)"></div>Verð í fríhöfn:</div><div class="wine-more-data-single-value" v-if="wine.price2">{{ wine.price2 }}kr</div><div class="wine-more-data-single-value" v-else>Ekki til sölu</div></div>
                                <div class="wine-more-data-single"><div class="wine-more-data-single-title">Framleiðandi:</div><div class="wine-more-data-single-value">{{ wine.producer }}</div></div>
                                <div class="wine-more-data-single"><div class="wine-more-data-single-title">Land:</div><div class="wine-more-data-single-value"><span><img class="country-icon" :src="getCountryIcon(wine)" alt=""></span>{{ wine.country }}</div></div>
                                <div class="wine-more-data-single"><div class="wine-more-data-single-title">Svæði:</div><div class="wine-more-data-single-value">{{ wine.area }}</div></div>
                                <div class="wine-more-data-single"><div class="wine-more-data-single-title">Þrúgur:</div><div class="wine-more-data-single-value">{{ wine.grapes }}</div></div>
                                <div class="wine-more-data-single"><div class="wine-more-data-single-title">Áfengisprósenta:</div><div class="wine-more-data-single-value">{{ wine.percentage }}%</div></div>
                                <div class="wine-more-data-single"><div class="wine-more-data-single-title">Matarpörun:</div><div class="wine-more-data-single-value"></div></div>
                                <div class="wine-more-data-categories">
                                    <div v-for="category in getCategories()" :key="category" class="wine-more-data-single-category-wrap">
                                        <div class="wine-more-data-single-category">
                                            {{category}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="wine-extra-content">
                <div class="wine-characteristics-wrap">
                    <!-- <div class="wine-about-characteristics">
                        <div class="wine-about-characteristics-pad">
                            <h1>Hvað Einkennir vínið?</h1>
                            <div class="bullet"></div><p>Lorem ipsum dolor sit, amet consectetur adipisicing.</p>
                            <div class="bullet"></div><p>Lorem ipsum dolor sit amet.</p>
                            <div class="bullet"></div><p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Illum, ex.</p>
                        </div>
                    </div> --><h1>Einkenni</h1>
                    <div class="wine-characteristics">
                        <div class="wine-characteristics-help" @mouseover="showCharModal = true" @mouseout="showCharModal = false">?</div>
                        <div class="wine-characteristics-help-modal" v-if="showCharModal">
                            <ul>
                                <li><b>Létt:</b> {{ charText[0] }}</li>
                                <li><b>Fylling:</b> {{ charText[1] }}</li>
                                <li><b>Mjúkt:</b> {{ charText[2] }}</li>
                                <li><b>Tannískt:</b> {{ charText[3] }}</li>
                                <li><b>Þurrt:</b> {{ charText[4] }}</li>
                                <li><b>Sætt:</b> {{ charText[5] }}</li>
                                <li><b>Engin sýra:</b> {{ charText[6] }}</li>
                                <li><b>Mikil sýra:</b> {{ charText[7] }}</li>
                            </ul>
                        </div>
                        <div class="wine-characteristics-col">
                            <div class="wine-characteristics-top-text" :title="charText[0]">Létt</div>
                            <div class="wine-characteristics-bar-wrap">
                                <div id="char-bar-1" v-bind:style="{ marginTop: charMarg1 + 'px' }" class="wine-characteristics-bar"></div>
                            </div>
                            <div class="wine-characteristics-bottom-text" :title="charText[1]">Fylling</div>
                        </div>
                        <div class="wine-characteristics-col" v-if="wine.type != 'white' && wine.type != 'sparkling' && wine.type != 'rose'">
                            <div class="wine-characteristics-top-text" :title="charText[2]">Mjúkt</div>
                            <div class="wine-characteristics-bar-wrap">
                                <div id="char-bar-2" v-bind:style="{ marginTop: charMarg2 + 'px' }" class="wine-characteristics-bar"></div>
                            </div>
                            <div class="wine-characteristics-bottom-text" :title="charText[3]">Tannískt</div>
                        </div>
                        <div class="wine-characteristics-col">
                            <div class="wine-characteristics-top-text" :title="charText[4]">Þurrt</div>
                            <div class="wine-characteristics-bar-wrap">
                                <div id="char-bar-3" v-bind:style="{ marginTop: charMarg3 + 'px' }" class="wine-characteristics-bar"></div>
                            </div>
                            <div class="wine-characteristics-bottom-text" :title="charText[5]">Sætt</div>
                        </div>
                        <div class="wine-characteristics-col">
                            <div class="wine-characteristics-top-text" :title="charText[6]">Engin sýra</div>
                            <div class="wine-characteristics-bar-wrap">
                                <div id="char-bar-4" v-bind:style="{ marginTop: charMarg4 + 'px' }" class="wine-characteristics-bar"></div>
                            </div>
                            <div class="wine-characteristics-bottom-text" :title="charText[7]">Mikil sýra</div>
                        </div>
                    </div>
                </div>
                <div v-if="relationWine1.id || relationWine2.id || relationWine3.id || relationWine4.id" class="wine-recommendations">
                    <h1>Svipuð vín</h1>
                    <div class="wine-recommendations-cards-wrap">
                        <div class="wine-recommendations-card-wrap" v-if="relationWine1.id">
                            <router-link v-if="relationWine1.id" :to="{ name: 'wine-info-page', params: {wineID:relationWine1.id} }">
                                <div class="wine-recommendations-card">
                                    <div class="wine-recommendations-card-image"><img :src="relationWine1.image | optimizeWine" alt=""></div>
                                    <div class="wine-recommendations-card-name">{{ relationWine1.name }}</div>
                                </div>
                            </router-link>
                        </div>
                        <div class="wine-recommendations-card-wrap" v-if="relationWine2.id">
                            <router-link v-if="relationWine2.id" :to="{ name: 'wine-info-page', params: {wineID:relationWine2.id} }">
                                <div class="wine-recommendations-card">
                                    <div class="wine-recommendations-card-image"><img :src="relationWine2.image | optimizeWine" alt=""></div>
                                    <div class="wine-recommendations-card-name">{{ relationWine2.name }}</div>
                                </div>
                            </router-link>
                        </div>
                        <div class="wine-recommendations-card-wrap" v-if="relationWine3.id">
                            <router-link v-if="relationWine3.id" :to="{ name: 'wine-info-page', params: {wineID:relationWine3.id} }">
                                <div class="wine-recommendations-card">
                                    <div class="wine-recommendations-card-image"><img :src="relationWine3.image | optimizeWine" alt=""></div>
                                    <div class="wine-recommendations-card-name">{{ relationWine3.name }}</div>
                                </div>
                            </router-link>
                        </div>
                        <div class="wine-recommendations-card-wrap" v-if="relationWine4.id">
                            <router-link v-if="relationWine4.id" :to="{ name: 'wine-info-page', params: {wineID:relationWine4.id} }">
                                <div class="wine-recommendations-card">
                                    <div class="wine-recommendations-card-image"><img :src="relationWine4.image | optimizeWine" alt=""></div>
                                    <div class="wine-recommendations-card-name">{{ relationWine4.name }}</div>
                                </div>
                            </router-link>
                        </div>
                    </div>
                </div>
                <div class="wine-comments-section">
                    <div class="wine-comments-content">
                        <div class="wine-comments-title">
                            <h1>Hafðu áhrif</h1>
                        </div>
                        <div class="wine-comment-rating-wrap">
                            <p class="wine-comment-rating-title">Hvaða einkunn gefur þú þessu víni?</p>
                            <div class="wine-comment-rating-sent" v-if="wineRated">
                                <p class="wine-comment-rating-comment">Takk fyrir atkvæðið!</p>
                            </div>
                            <div class="wine-comment-rating" v-else>
                                <div v-for="i in 10" :key="i" v-on:click="selectedRating = i" @mouseover="hoveredRating = i" @mouseout="hoveredRating = selectedRating">
                                    <img v-if="hoveredRating >= i" class="rating-icon" src="../assets/icons/star-filled.png" alt="">
                                    <img v-else class="rating-icon" src="../assets/icons/star-empty.png" alt="">
                                </div>
                            </div>
                            <input v-if="!wineRated" type="button" value="Senda" class="submit-rating-button" v-on:click="sendRating(selectedRating)" :disabled="selectedRating == 0">
                        </div>
                        <!--<div class="wine-comment-wrap">
                            <p class="wine-comment-rating-title">Athugasemdir</p>
                            <div class="fb-comments" :data-href="'http://vinval.is/vin/' + wine.id" data-numposts="5"></div>
                        </div>-->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex'
const fb = require('../firebaseConfig.js')


export default {
    props: {
        wineID: String
    },
    data() {
        return {
            wine: {},
            hoveredRating: 0,
            selectedRating: 0,
            wineRated: false,
            charMarg1: 0,
            charMarg2: 0,
            charMarg3: 0,
            charMarg4: 0,
            relationWine1: {name: "", image: "", id: ""},
            relationWine2: {name: "", image: "", id: ""},
            relationWine3: {name: "", image: "", id: ""},
            relationWine4: {name: "", image: "", id: ""},
            charText: [
                'Vínið er mjúkt og þægilegt.',
                'Vínið er kröftugt, bragðmikið og varir lengi í munni.',
                'Vínið er mjúkt og hefur mjúk og lítil tannín.',
                'Vínið er tannínríkt. Tannín kemur úr hýði vínberjanna og það skilur eftir sig þurra áferð í munni. Tannínrík vín eru góð með þyngri máltíðum.',
                'Vínið er með þurrt eftirbragð.',
                'Vínið er með sætum bragðtón og/eða ávaxtaríkt.',
                'Vínið er með litla sýru.',
                'Vínið er sýruríkt.',
            ],
            showCharModal: false
        }
    }, // LÁTA GETWINE() RUNNA EFTIR COMPUTED
    methods: {
        findWine: function() {
            if (this.wines){
                const foundWine = this.wines.filter(wine => {
                    return wine.id == this.wineID
                })

                if (foundWine.length) {
                    return foundWine[0]
                }
            }
        },
        setCharacteristicsValues: function() {
            if (this.wine) {
                var value1, value2, value3, value4
                var mul

                mul = parseInt(this.wine.characteristics1)/100
                value1 = mul*175

                mul = parseInt(this.wine.characteristics2)/100
                value2 = mul*175

                mul = parseInt(this.wine.characteristics3)/100
                value3 = mul*175

                mul = parseInt(this.wine.characteristics4)/100
                value4 = mul*175

                this.charMarg1 = value1
                this.charMarg2 = value2
                this.charMarg3 = value3
                this.charMarg4 = value4
            }
        },
        getCategories: function() {
            var categoriesArray = []
            this.wine.categories.forEach(wineCategory => {
                this.categories.forEach(category => {
                    if (wineCategory == category.id) {
                        categoriesArray.push(category.name)
                    }
                })
            });
            return categoriesArray
        },
        isWineOfTheMonth(wine) {
            var wotm
            var currentMonth = new Date().getMonth()
            var currentYear = new Date().getFullYear()
            for (let index = 0; index < this.months.length; index++) {
                if (this.months[index].month == currentMonth+1 && this.months[index].year == currentYear) {
                    wotm = this.months[index]
                }
            }
            if (wotm) {
                if (wine.id == wotm.wineid) {
                    return true
                }
            }
            return false
        },
        sortedAgeRating(ratings) {
            var ratingsCopy = ratings.slice()
            ratingsCopy.sort(function(a,b){return b.year - a.year})
            return ratingsCopy
        },
        sendRating(rating) {
            var now = new Date().toISOString()
            fb.ratingsCollection.add({
                wineid: this.wine.id,
                rating: rating,
                date: now
            })
            this.wineRated = true
        },
        openUrl(url) {
            window.open(url)
        },
        getCountryIcon(wine) {
            for (let i = 0; i < this.countries.length; i++) {
                const e = this.countries[i];
                if (e.name == wine.country) {
                    return e.icon
                }
            }
            return null
        }
    },
    mounted() {

    },
    watch: {
        wines: function() {
            this.wine = this.findWine()
            this.setCharacteristicsValues()
        },
        wine: function() {
            for (let i = 0; i < this.wines.length; i++) {
                if (this.wines[i].id == this.wine.relationWine1) {
                    this.relationWine1 = {name:this.wines[i].name, image:this.wines[i].image, id:this.wines[i].id}
                }
                if (this.wines[i].id == this.wine.relationWine2) {
                    this.relationWine2 = {name:this.wines[i].name, image:this.wines[i].image, id:this.wines[i].id}
                }
                if (this.wines[i].id == this.wine.relationWine3) {
                    this.relationWine3 = {name:this.wines[i].name, image:this.wines[i].image, id:this.wines[i].id}
                }
                if (this.wines[i].id == this.wine.relationWine4) {
                    this.relationWine4 = {name:this.wines[i].name, image:this.wines[i].image, id:this.wines[i].id}
                }
            }
        }
    },
    computed: {
        ...mapState(['wines', 'categories', 'months', 'countries', 'currentWineTopAd'])
        
    },
    created() {
        this.wine = this.findWine()
        this.setCharacteristicsValues()
    },
    filters: {
        optimizeWine: function(url) {
            var newUrl = url.replace('upload/', 'upload/q_auto,f_auto,h_500/')
            return newUrl
        }
    }
    
}
</script>

<style>
@media only screen and (max-width: 768px) {
    .wine-info-content {
        margin-top: 2rem;
        height:auto;
        border-radius: 10px 10px 0 0;
        background-color: white;
    }
    .wine-image-wrap {
        width:100%;
        height: 400px;
    }
    .wine-image {
        position: relative;
        height:100%;
    }
    .wine-image-source {
        margin-top: -10px;
        opacity: 60%;
        font-size: 10px;
        text-align: left;
        margin-left: 10px;
    }
    .wine-image img {
        position: absolute;
        max-height:90%;
        top:0;
        bottom: 0;
        left:0;
        right:0;
        margin:auto;
    }
    .wine-info-main-col1 {
        width:100%;
    }
    .wine-info-main-col2 {
        width:100%;
    }
    .wine-info-main {
        display: inline-block;
        text-align: left;
        width: 95%;
    }
    .wine-info-main-marg {
        margin:10px;
    }
    .wine-title {
        font-weight: normal;
        margin: 0;
        font-size: 36px;
        color: #b33b3b;
    }
    .wine-description {
        margin-top: 10px;
        font-size: 24px;
    }
    .wine-rating {
        margin-top: 10px;
        font-size: 26px;
        width:100%;
        text-align: right;
    }
    .wine-ageRating-wrap {
        margin-top: 10px;
    }
    .wine-ageRating-title {
        font-size: 22px;
        text-align: left;
    }
    .wine-ageRating {
        text-align: left;
        margin-top: 5px;
        font-size: 16px;
    }
    .wine-wotm {
        right:0;
        top: 0;
        margin-top: -395px;
    }
    .wine-more-data {
        margin-top: 50px;
        font-size: 18px;
    }
    .wine-more-data-single {
        padding-bottom: 15px;
    }
    .wine-more-data-single-title {
        display:inline-block;
        width:50%;
        vertical-align: top;
    }
    .wine-more-data-single-value {
        display:inline-block;
        width:50%;
        text-align: right;
        vertical-align: top;
    }
    .wine-more-data ul {
        list-style: none;
    }
    .wine-more-data-categories {
        width: 100%;
        max-height: 140px;
        display:flex;
        flex-wrap: wrap;
        justify-content: center;
    }
    .wine-more-data-single-category-wrap {
        padding: 2px 5px;
        background-color: #b33b3b;
        height: 25px;
        margin-right: 5px;
        margin-bottom: 5px;
        border-radius: 5px;
    }
    .wine-more-data-single-category {
        font-size: 16px;
        
        color: white;
    }
    .wine-more-data li::before {
        content: "\2022";  /* Add content: \2022 is the CSS Code/unicode for a bullet */
        color: #b33b3b; /* Change the color */
        font-weight: bold; /* If you want it to be bold */
        display: inline-block; /* Needed to add space between the bullet and the text */
        width: 1em; /* Also needed for space (tweak if needed) */
        margin-left: -1em; /* Also needed for space (tweak if needed) */
    }
    .wine-extra-content {
        clear:both;
    }
    .wine-characteristics-wrap {
        width: 100%;
        margin-top: 30px;
        height: 400px;
        background-color: white;
    }
    .wine-about-characteristics-pad {
        padding:30px 30px;
    }
    .wine-about-characteristics {
        position: relative;
        width:100%;
        background-color: #fff9f9;
    }
    .wine-about-characteristics h1 {
        font-size: 32px;
        margin:0;
    }
    .wine-about-characteristics p {
        margin:0;
        font-size: 22px;
        text-align: left;
    }
    .bullet {
        position: absolute;
        width: 7px;
        height: 7px;
        border-radius: 50%;
        margin-left: -15px;
        margin-top: 14px;
        background-color: #b33b3b;
    }
    .wine-characteristics {
        width:100%;
        padding:10px 0;
        height:350px;
        display:flex;
        justify-content: space-around;
    }
    .wine-characteristics > div {
        height:200px;
    }
    .wine-characteristics h1 {
        margin:0;
        margin-bottom: 20px;
    }
    .wine-characteristics-col {
        width:25%;
        height: 100%;
        float:left;
    }
    .wine-characteristics-bar-wrap {
        height:100%;
        background-color: #fff9f9;
        border: 1px solid #a8a5a3;
        width:25px;
        margin: 0 auto;
        margin-top: 5px;
        margin-bottom: 5px;
        border-radius: 20px;
    }
    .wine-characteristics-bar {
        height:25px;
        border-radius: 20px;
        width:100%;
        margin: 0 auto;

        background-color: #b33b3b; 
    }
    .wine-characteristics-help {
        display: none;
    }
    .wine-recommendations-cards-wrap {
        display:flex;
        justify-content: center;
        flex-wrap: wrap;
        padding-top: 2px;
    }
    .wine-recommendations-card-wrap {
        width: 50%;
        margin-bottom: 30px;
    }
    .wine-recommendations-card {
        
    }
    .wine-comments-content {
        position: relative;
        margin-top: 30px;
        width:100%;
        height: 400px;
        background-color: white;
        border-radius: 0 0 10px 10px;
    }
    .wine-comments-title {
        margin-top: 10px;
        display: inline-block;
    }
}
@media only screen and (min-width: 769px) {
    .wine-info-content {
        margin-top: 2rem;
        height:500px;
        border-radius: 10px 10px 0 0;
        background-color: white;
    }
    .wine-image-wrap {
        width:20%;
        height:100%;
        float:left;
    }
    .wine-image {
        position: relative;
        height:100%;
    }
    .wine-image img {
        position: absolute;
        max-height:90%;
        top:0;
        bottom: 0;
        left:0;
        right:0;
        margin:auto;
    }
    .wine-image-source {
        margin-top: -25px;
        opacity: 60%;
        font-size: 10px;
        text-align: left;
        margin-left: 10px;
    }
    .wine-info-main-col1 {
        position: relative;
        height: 100%;
        width:65%;
        float:left;
    }
    .wine-info-main-col2 {
        width:35%;
        float:left;
    }
    .wine-info-main {
        display: inline-block;
        text-align: left;
        height: 470px;
        width: 80%;
    }
    .wine-info-main-marg {
        margin:10px;
        height: 100%;
    }
    .wine-title {
        font-weight: normal;
        margin: 0;
        max-width: calc(100% - 150px);
        font-size: 36px;
        color: #b33b3b;
    }
    .wine-description {
        margin-top: 10px;
        font-size: 24px;
        /* height:350px; */
        padding-right: 20px;
    }
    .wine-rating {
        position: absolute;
        bottom: 0;
        margin-top: 10px;
        font-size: 26px;
    }
    .wine-ageRating-wrap {
        position: absolute;
        right: 0;
        margin-right: 20px;
        bottom: 0;
    }
    .wine-ageRating-title {
        font-size: 20px;
        text-align: center;
    }
    .wine-ageRating {
        text-align: right;
    }
    .wine-wotm {
        right:0;
        top: 0;
        margin-right: 30px;
        margin-top: 10px;
    }
    .wine-more-data {
        padding-right:10px;
        font-size: 18px;
        display:inline-block;
        width: 100%;
    }
    .wine-more-data-single {
        padding-bottom: 15px;
    }
    .wine-more-data-single-title {
        display:inline-block;
        width:50%;
        vertical-align: middle;
    }
    .wine-more-data-single-value {
        display:inline-block;
        width:50%;
        text-align: right;
        vertical-align: top;
    }

    .wine-more-data-categories {
        width: 100%;
        max-height: 140px;
        display:flex;
        flex-wrap: wrap;
        justify-content: center;
    }
    .wine-more-data-single-category-wrap {
        padding: 2px 5px;
        background-color: #b33b3b;
        height: 25px;
        margin-right: 5px;
        margin-bottom: 5px;
        border-radius: 5px;
    }
    .wine-more-data-single-category {
        font-size: 16px;
        
        color: white;
    }
    .wine-more-data ul {
        list-style: none;
    }
    .wine-more-data li::before {
        content: "\2022";  /* Add content: \2022 is the CSS Code/unicode for a bullet */
        color: #b33b3b; /* Change the color */
        font-weight: bold; /* If you want it to be bold */
        display: inline-block; /* Needed to add space between the bullet and the text */
        width: 1em; /* Also needed for space (tweak if needed) */
        margin-left: -1em; /* Also needed for space (tweak if needed) */
    }
    .wine-extra-content {
        clear:both;
    }
    .wine-characteristics-wrap {
        width: 100%;
        height:400px;
        margin-top: 30px;
        background-color: white;
    }
    .wine-about-characteristics-pad {
        padding:30px 30px;
    }
    .wine-about-characteristics {
        position: relative;
        width:30%;
        height:100%;
        float:left;
        background-color: #fff9f9;
    }
    .wine-about-characteristics h1 {
        font-size: 32px;
        margin:0;
    }
    .wine-about-characteristics p {
        font-size: 22px;
        text-align: left;
    }
    .bullet {
        position: absolute;
        width: 7px;
        height: 7px;
        border-radius: 50%;
        margin-left: -15px;
        margin-top: 14px;
        background-color: #b33b3b;
    }
    .wine-characteristics {
        position: relative;
        height:200px;
        width:100%;
        padding:10px 0;
        float:left;
        display:flex;
        justify-content: space-around;
    }
    .wine-characteristics-help {
        position: absolute;
        top: 0;
        right: 0;
        margin-top: -50px;
        margin-right: 20px;
        background-color: #f0f0f0;
        width: 20px;
        height: 20px;
        border-radius: 30px;
        color: black;
        line-height: 20px;
        box-shadow: 0 1px 4px #a8a5a3;
        cursor: help;
    }
    .wine-characteristics-help-modal {
        width: 400px;
        right: 50px;
        margin-top: -30px;
        background-color: white;
        position: absolute;
        text-align: left;
        box-shadow: 0 1px 4px #a8a5a3;
    }
    .wine-characteristics-col {
        width:25%;
        height: 100%;
        float:left;
    }
    .wine-characteristics-bar-wrap {
        height:100%;
        background-color: #fff9f9;
        border: 1px solid #a8a5a3;
        width:25px;
        margin: 0 auto;
        margin-top: 5px;
        margin-bottom: 5px;
        border-radius: 20px;
    }
    .wine-characteristics-bar {
        height:25px;
        border-radius: 20px;
        width:100%;
        margin: 0 auto;

        background-color: #b33b3b; 
    }
    .wine-recommendations-cards-wrap {
        display:flex;
        justify-content: space-around;
        height: 220px;
    }
    .wine-recommendations {
        height: 300px;
    }
    .wine-recommendations-card {
        margin-left: 10px;
        margin-right: 10px;
    }
    .wine-comments-content {
        position: relative;
        margin-top: 30px;
        width:100%;
        height: 400px;
        background-color: white;
        border-radius: 0 0 10px 10px;
    }
    .wine-comments-title {
        margin-top: 10px;
        display: inline-block;
    }
}
@media only screen and (min-width: 1200px) {
    .wine-wotm {
        right:0;
        top: 0;
        margin-right: 30px;
        margin-top: 10px;
    }
}
.icon-atvr {
    /*background-image: url('../assets/icons/atvr.png');*/
    vertical-align: middle;
    background-image: url('../assets/icons/wine-link-small.png');
}
.icon-dutyfree {
    vertical-align: middle;
    background-image: url('../assets/icons/dutyfree.svg');
}
.wine-more-data-single-icon {
    width: 20px;
    height: 20px;
    margin-top: -3px;
    background-size: 20px;
    background-position-y: 0px;
    background-repeat: no-repeat;
    display: inline-block;
    padding-left: 5px;
    cursor: pointer;
}

.wine-characteristics-wrap h1 {
    color: #b33b3b;
}
.wine-recommendations h1 {
    color: #b33b3b;
}
.wine-comments-title h1 {
    color: #b33b3b;
}
.wine-info-main-col1 {
    position: relative;
}
.wine-wotm {
    position: absolute;
    background-color: #b33b3b;
    width:100px;
    text-align: center;
    border-radius: 5px;
    color: white;
    padding: 4px;
}
.wine-recommendations {
    width: 100%;
    margin-top: 30px;
    background-color: white;
}
.wine-recommendations-cards-wrap {
    display:flex;
    padding-top: 2px;
    margin:auto;
    max-width: 900px;
}
.wine-recommendations-card {
    width: 130px;
    padding: 0 10px;
    height:200px;
    display: inline-block;
    border-radius: 10px;
    -webkit-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.2);
    -moz-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.2);
    box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.2);
}
.wine-recommendations-card-name {
    font-size: 16px;
    text-align: center;
}
.wine-recommendations-card-image {
    padding-top: 10px;
    height:140px;
}
.wine-recommendations-card-image img {
    height:130px;
}
.wine-comments-title h1 {
    margin-bottom: 0px;
}
.wine-comment-rating {
    display:flex;
    margin: 0 auto;
    width: 300px;
}
.wine-comment-rating div {
    cursor: pointer;
    height: 26px;
    width: 26px;
    padding: 2px;
}
.wine-comment-rating div img {
    height: 100%;
    width: 100%;
}
.wine-comment-rating-title {
    font-size: 20px;
}
.wine-comment-rating-comment {
    font-size: 18px;
}
.submit-rating-button {
    margin: 0 auto;
    border: none;
    border-radius: 10px;
    padding: 10px;
    font-size: 16px;
    width: 100px;
    cursor: pointer;
    bottom: 0;
    margin-top: 15px;
    background-color: #B33B3B;
    color: white;
}
.submit-rating-button:disabled {
    background-color: #adadad;
}
</style>